import React, { FunctionComponent, useContext } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { Stack, DropdownOption, mapToDropdownOption, FormAutocomplete, FormAutocompleteRules } from "sprint-common-web";

import { DistributorsDataContext } from "../../data/lookup-data-providers/DistributorsDataProvider";

export interface FormDistributorSearchDropdownProps {
    initOptions?: DropdownOption[];
    control: Control;
    name: string;
    rules?: FormAutocompleteRules;
    errors: FieldErrors;
    disabled?: boolean;
    placeholder: string;
    label: string;
}

export const FormDistributorSearchDropdown: FunctionComponent<FormDistributorSearchDropdownProps> = (
    props: FormDistributorSearchDropdownProps
) => {
    const { suggestDistributor } = useContext(DistributorsDataContext);

    const handleSearch = async (query: string): Promise<DropdownOption[]> => {
        if (!query || query.length < 2) {
            return [];
        }

        const distributors = await suggestDistributor(query);

        return distributors?.map((distributor) => mapToDropdownOption(distributor)) ?? [];
    };

    return (
        <Stack>
            <FormAutocomplete
                initOptions={props.initOptions ?? []}
                onCustomSearch={handleSearch}
                control={props.control}
                errors={props.errors}
                rules={props.rules}
                name={props.name}
                placeholder={props.placeholder}
                label={props.label}
                disabled={props.disabled}
            />
        </Stack>
    );
};
